module.exports = __webpack_public_path__ + "static/media/virtual-reality-coding-middle-school.f671d80c.jpg";